import App from './App'
import ElementAddress from 'element-address'
import ElementDataset from 'element-dataset'
import ElementUI from 'element-ui'
import IdCard from '../static/IdCard'
import Print from 'vue-print-nb'// √
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueBarcode from '@xkeshi/vue-barcode'// @chenfengyuan/vue-barcode
import axios from 'axios'
import promise from 'es6-promise'
import qs from 'qs'
import router from './router'
import smartParse from 'vue-smart-parse'// smartParsePro
import store from './store/store'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-address/lib/index.css'
import 'es6-promise/auto'
import './utils/rem'

promise.polyfill();
require('es6-promise').polyfill()
require("es6-promise-always")
ElementDataset()

Vue.config.productionTip = false
Vue.prototype.$qs = qs;
Vue.prototype.validid = IdCard;

Vue.use(ElementUI);
Vue.use(VueAxios, axios)
Vue.use(ElementAddress);
Vue.component('barcode', VueBarcode);
Vue.use(smartParse)

// axios.defaults.baseURL = 'http://localhost:9124'
axios.defaults.baseURL = 'https://express-api.creatorvoler.com'

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code != 200) {
      ElementUI.Message.error(res.message || res.msg || '请求失败')
    }
    return response
  },
  error => {
    ElementUI.Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js